import { connect } from 'react-redux'
import Propiedades from '../../../components/Sections/Propiedades'
import { setListType, searchPropiedades } from '../../../actions/propiedades';
import { updateUrl } from '../../../actions/meta'
import { showDetails } from '../../../actions/header'
import { changeSearchOrigin, saveOriginPath, retrivePropertyTypes } from '../../../actions/searchBar'

const mapStateToProps = (state, ownProps) => {
  return {
    listType: state.propiedades.listType,
    properties: state.propiedades.list,
    page: state.meta.page,
    total_pages: state.meta.total_pages,
    total_results: state.meta.total_results,
    loading: state.propiedades.loading,
    urlLocation: ownProps.location,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onClickViewGallery: () => dispatch(setListType('gallery')),
    onClickViewMap: () => dispatch(setListType('map')),
    setHeaderDetails: () => dispatch(showDetails()),
    changeSearchOrigin: () => dispatch(changeSearchOrigin()),
    saveOriginPath: (value) => dispatch(saveOriginPath(value)),
    retrivePropertyTypes: (value) => dispatch(retrivePropertyTypes(value)),
    searchPropiedades: () => dispatch(searchPropiedades()),
    updateUrl: (q) => {dispatch(updateUrl(q))}
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Propiedades)



// WEBPACK FOOTER //
// ./src/containers/Sections/Propiedades/index.js